__turbopack_context__.v({
  "article-intro": "_3axIPa_article-intro",
});
